import { format, parseISO } from "date-fns"
import { arSA, enUS } from "date-fns/locale"

const formatActivityDate = (utcDateString, language) => {
  if (!utcDateString) return "-"

  const date =
    typeof utcDateString === "string"
      ? parseISO(utcDateString)
      : new Date(utcDateString)

  if (Number.isNaN(date.getTime())) return "-"

  if (language === "sa") {
    return format(date, "d MMMM yyyy، h:mm a", { locale: arSA })
  }

  return format(date, "d MMMM yyyy 'at' h:mm a", { locale: enUS })
}

export default formatActivityDate
